<!-- eslint-disable style/max-len -->
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.16602 1.667C9.62622 1.667 9.99929 2.04014 9.99935 2.50033C9.99935 2.96057 9.62625 3.33367 9.16602 3.33367C5.94439 3.33367 3.33274 5.94539 3.33268 9.167C3.33268 12.3887 5.94436 15.0003 9.16602 15.0003C12.3877 15.0003 14.9994 12.3887 14.9994 9.167C14.9994 8.70681 15.3725 8.33367 15.8327 8.33367C16.2929 8.33367 16.666 8.70681 16.666 9.167C16.666 10.9378 16.0509 12.5641 15.0246 13.8472L18.0861 16.9087C18.4114 17.2341 18.4114 17.7617 18.0861 18.0871C17.7607 18.4125 17.2332 18.4124 16.9077 18.0871L13.8454 15.0256C12.5624 16.0517 10.9366 16.667 9.16602 16.667C5.02388 16.667 1.66602 13.3091 1.66602 9.167C1.66607 5.02491 5.02392 1.667 9.16602 1.667Z"
      fill="currentColor"
    />
    <path
      d="M13.0853 1.85743C13.152 1.60351 13.5134 1.60351 13.5801 1.85743L13.8405 2.8519C14.0509 3.65502 14.678 4.28212 15.4811 4.49252L16.4756 4.75375C16.7295 4.82052 16.7296 5.18108 16.4756 5.24773L15.4811 5.50815C14.678 5.71854 14.0509 6.34565 13.8405 7.14877L13.5801 8.14324C13.5135 8.39742 13.1519 8.39742 13.0853 8.14324L12.8249 7.14877C12.6145 6.34565 11.9874 5.71854 11.1842 5.50815L10.1898 5.24773C9.93581 5.18108 9.93591 4.82052 10.1898 4.75375L11.1842 4.49252C11.9874 4.28212 12.6145 3.65502 12.8249 2.8519L13.0853 1.85743Z"
      fill="currentColor"
    />
  </svg>
</template>
